module.exports = __webpack_public_path__ + "img/HTL.b6819848.png";